<template>
  <v-card
    v-if="Object.keys(selectedInfos).length"
    flat
    tile
  >
    <v-card-title>{{ datasets[Object.keys(selectedInfos)[currentFeature]].title }}</v-card-title>
    <v-card-text
      class="py-0"
    >
      <v-window v-model="currentFeature">
        <v-window-item
          v-for="(datasetId, i) in Object.keys(selectedInfos)"
          :key="`card-${i}`"
        >
          <feature-details :id="datasetId" />
        </v-window-item>
      </v-window>
    </v-card-text>
    <v-card-actions
      v-if="Object.keys(selectedInfos).length > 1"
      class="justify-space-between"
    >
      <v-btn
        icon
        @click="prev"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-item-group
        v-model="currentFeature"
        class="text-center"
        mandatory
      >
        <v-item
          v-for="(datasetId, n) in Object.keys(selectedInfos)"
          :key="`btn-${n}`"
        >
          <v-btn
            slot-scope="{ active, toggle }"
            :input-value="active"
            style="width:8px;height:8px"
            icon
            @click="toggle"
          >
            <v-icon
              :size="active ? 14: 8"
              :style="(active ? `margin-top:-3px;`: '')"
            >
              mdi-circle
            </v-icon>
          </v-btn>
        </v-item>
      </v-item-group>
      <v-btn
        icon
        @click="next"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import FeatureDetails from './feature-details.vue'

export default {
  components: {
    FeatureDetails
  },
  data: () => ({
    currentFeature: 0
  }),
  computed: {
    ...mapState(['selectedInfos', 'datasets'])
  },
  watch: {
    selectedInfos () {
      this.currentFeature = 0
    }
  },
  methods: {
    next () {
      this.currentFeature = this.currentFeature + 1 === Object.keys(this.selectedInfos).length ? 0 : this.currentFeature + 1
    },
    prev () {
      this.currentFeature = this.currentFeature - 1 < 0 ? Object.keys(this.selectedInfos).length - 1 : this.currentFeature - 1
    }
  }
}
</script>
